import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow"; 
import { useState } from "react";
import Modal from "../Modal";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";


const ListOrganization = ({ onOpenAddOrganization, onOpenEditOrganization }) => {

  const [orgList, setOrgList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const aiDishaApi = createInstance("DISHA");
  const [searchTerm, setSearchTerm] = useState("");
  const [deactivateId, setDeactivateId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  

  useEffect(()=>{
    getOrgList();
  },[]);

  const getOrgList = async () =>{
    await aiDishaApi.get('/get-all-organizations')
    .then((response)=>{
      setOrgList(response.data);
      console.log("ORG LIST : ",response.data);
    })
    .catch((error)=>{
      console.log("Error fetching active organizations", error);
    })
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = (orgId, status) => {
    console.log("Deactivate ID",orgId);
    setDeactivateId(orgId);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleAddOrganizationClick = () => {
    onOpenAddOrganization();
     // Call the function passed from AdminLandingPage
  };

  const handleEditOrg = (org) => {
    // Pass the organization data to the parent component
    onOpenEditOrganization(org);
  }

  //Search interviews based on applied position
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  //Deactivate Organization
  const handleDeactivateOrganization = async (deactivateOrgId, currentStatus ) => {
    try {
      console.log("2 deact id",deactivateOrgId);
      const newStatus = currentStatus  === "Active" ? "Inactive" : "Active";
      const response = await aiDishaApi.patch(`/soft-delete-organization/?org_id=${deactivateOrgId}&status=${newStatus}`);

      if (response.status === 200) {
        Toast.success("Organization deactivated successfully");
        getOrgList();
      }
    } catch (error) {
      console.error("Error deactivating Organization:", error);
      Toast.error("Failed to deactivate Organization");
    }
  };


  const header = [
    {
      id: "Organization ID",
      name: "Organization Name",
      domain: "Domain",
      email: "Email ID",
      mobile: "Contact",
      address: "Address",
      sector: "Sector",
      action: "Action",
    },
  ];

  const filteredOrgList = orgList.filter((row) => 
    row.organization_name?.toLowerCase().includes(searchTerm.toLowerCase()) 
  );


  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          // background: alpha("#B9B9B9", 0.2), // Opacity set to 20%,
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}
          >
            List Organization
          </Typography>
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              border: "1px solid #A7A7A7",
              backgroundColor:"#033538"
            }}
          >
            <IconButton type="button" sx={{ p: "8px", backgroundColor:"#033538" }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "poppins", color:"white"}}
              placeholder="Search by Organization Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm} onChange={handleSearch}/>
          </Paper>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "right" }}>
          <Button
            variant="contained"
            onClick={handleAddOrganizationClick}
            sx={{
              backgroundColor: "#033538",
              marginRight: "10px",
              color: "white",
              fontFamily: "poppins",
            }}
          >
            
            Add organization
          </Button>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {header.map((head) => (
                    <TableRow key={head.id}>
                      <TableCell sx={{ color: "white", borderBottom: 0, borderLeft: "1px solid black"   }}>{head.id}</TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0  }}>
                        {head.name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0  }}>
                        {head.domain}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.email}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.mobile}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0}}>
                        {head.address}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.sector}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredOrgList && filteredOrgList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, index) => (
                      <TableRow
                        key={n.organization_id}
                        sx={{ backgroundColor: "#033538", marginRight: "30px" }}
                      >
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.organization_id}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.organization_name}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.organization_domain}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.email}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.contact_number}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.organization_address}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.sector}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom:"1px solid black",
                            borderRight:"1px solid black",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "black",
                              color: "white",
                              marginRight: "10px",
                              fontFamily: "poppins",
                              height: "20px",
                              width: "80px",
                            }}
                            onClick={()=>handleEditOrg(n)}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                             backgroundColor:
                                  n.status === "Active"
                                    ? "#f44336"
                                    : "#4caf50",
                                color: "#ffffff",
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                            }}
                            color="error"
                            onClick={()=>handleModalOpen(n.organization_id, n.status)}
                          >
                            {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredOrgList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal 
      isOpen={isModalOpen} 
      onClose={handleModalClose} 
      title="Organization" 
      action={()=>handleDeactivateOrganization(deactivateId,selectedStatus)}
      actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};
export default ListOrganization;